import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState } from "../../types";

export const setZoom = (
  state: ApplicationState,
  action: PayloadAction<ApplicationState["zoom"]>
) => {
  state.zoom = action.payload;
};
